module.exports = __webpack_public_path__ + "fonts/8ba0d585d2031db2b0e0d46db18dbece.svg";